import { useState } from 'react';
import styled from 'styled-components';

import Typography from 'app/components/Typography';

import { ReactComponent as EditIcon } from 'app/assets/icons/edit.svg';
import { ReactComponent as TrashIcon } from 'app/assets/icons/trash.svg';

import RoomNameModal from './RoomNameModal';

const WrapperIcon = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 8px;
  border: 1px solid var(--neutral-3);
  cursor: pointer;
`;

export const ChangeColorComp = ({
  onChangeColor,
  onRoomNameChange,
  selectedDetailName,
  onDeleteRoom,
  isEditRack,
}: {
  onChangeColor: (color: string) => void;
  onRoomNameChange?: (name: string) => void;
  selectedDetailName: string;
  onDeleteRoom: () => void;
  isEditRack: boolean;
}) => {
  const [isRoomNameModalOpen, setIsRoomNameModalOpen] = useState(false);

  const handleOpenRoomNameModal = () => {
    setIsRoomNameModalOpen(true);
  };

  const handleCloseRoomNameModal = () => {
    setIsRoomNameModalOpen(false);
  };

  const handleSaveRoomName = (roomName: string) => {
    if (onRoomNameChange) {
      onRoomNameChange(roomName);
    }
  };

  return (
    <>
      <div
        className="d-flex"
        style={{
          position: 'absolute',
          bottom: 80,
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#FFFFFF',
          border: '1px solid var(--neutral-3)',
          borderRadius: 12,
          boxShadow:
            '23.487px 32.379px 94px 0px rgba(25, 36, 64, 0.12), 4.697px 6.476px 15.275px 0px rgba(25, 36, 64, 0.12), 0.4px 0.533px 5px 0px rgba(25, 36, 64, 0.08)',
        }}
      >
        {!isEditRack ? (
          <div
            className="d-flex align-items-center"
            style={{ padding: 16, borderRight: `1px solid var(--neutral-3)` }}
          >
            <Typography variant="body-5" style={{ marginRight: 12 }}>
              Change color:
            </Typography>

            <div className="d-flex" style={{ gap: 12 }}>
              {['#D1EAFF', '#EDE5FF', '#FAE3EA', '#FAEED2', '#D0F5E2'].map((color) => (
                <div
                  style={{
                    width: 24,
                    height: 24,
                    backgroundColor: color,
                    borderRadius: '50%',
                    cursor: 'pointer',
                  }}
                  onClick={() => onChangeColor(color)}
                ></div>
              ))}
            </div>
          </div>
        ) : null}

        <div className="d-flex align-items-center" style={{ padding: '8px 16px', gap: 12 }}>
          {!isEditRack ? (
            <WrapperIcon onClick={handleOpenRoomNameModal}>
              <EditIcon />
            </WrapperIcon>
          ) : null}

          <WrapperIcon onClick={onDeleteRoom}>
            <TrashIcon />
          </WrapperIcon>
        </div>
      </div>

      {isRoomNameModalOpen && (
        <RoomNameModal
          title={isEditRack ? 'Rack Name' : 'Room Name'}
          selectedRoomName={selectedDetailName}
          onClickCloseModal={handleCloseRoomNameModal}
          onSaveRoomName={handleSaveRoomName}
        />
      )}
    </>
  );
};
